import ITexts from "./ITexts";

const de: ITexts = {
  donation_project_list_header: "Spende",
  donation_project_list_item_go_to_project: "Zur Organisation",
  donation_1_donate_now_1: "Jetzt ab ",
  donation_1_donate_now_2: " spenden",
  donation_abort_button: "Abbrechen",
  donation_info: "Hinweis",
  donation_alert: "Any alert message",
  donation_now_disabled: "Anmelden und spenden",
  donation_continue: "fortsetzen",
  donation_progress_bar_by: "von",
  donation_progress_bar_donator: "Donator",
  donation_progress_bar_donators: "Donatoren",
  donation_side_bar_requiredBudget: "Spendenziel",
  donation_side_bar_region: "Region",
  donation_side_bar_mainFocus: "Hauptfokus",
  donation_side_bar_matchFunding: "Matchfunding",
  donation_close_button: "Close"
};

export default de;
